module.exports = __webpack_public_path__ + "static/media/landing-page-buyer.ef9bb5be.webp";